
import { AuthPayload } from '@/interfaces/ui.interface'
import api from '@/plugins/axios'

export default {
  async fetchTestimonials({ commit }: any, search: any) {
      const payload: AuthPayload = {
        data: null,
        success: false,
        message: '',
        show: false
      }
    try {
      const response = await api.get('/testimonial', {
        params: search.params
      })
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setTestimonias', payload)
    }
  },
  async postTestimonials({ commit }: any, formData: FormData) {
      const payload: AuthPayload = {
        data: null,
        success: false,
        message: '',
        show: true
      }
    try {
      const response = await api.post('/addTestimonia', formData)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('addTestimonialsItem', payload)
    }
  },
  async putTestimonial({ commit }: any, { id, formData }: { id: number, formData: FormData }) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
      try {
        const response = await api.post(`/updateTestimonial/${id}`, formData)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion editada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('editTestimonialsItem', payload)
    }
  },
  async delTestimonial({ commit }: any, id: number) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
      try {
        const response = await api.delete(`/deleteTestimonial/${id}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion editada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('delTestimonialsItem', payload)
    }
  }
}
